import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import { Tooltip } from 'bootstrap';

const EpTooltip = ({
  children, title, placement, trigger,
}) => {
  const TooltipDemo = () => {
    const tooltipRef = useRef();

    useEffect(() => {
      // eslint-disable-next-line no-unused-vars
      const tooltip = new Tooltip(tooltipRef.current, {
        title,
        placement,
        trigger,
      });
    });

    return (
      <span ref={tooltipRef} className="tooltip__body">
        {children}
      </span>
    );
  };

  return (
    <TooltipDemo />
  );
};

export default EpTooltip;

EpTooltip.defaultProps = {
  placement: 'top',
  trigger: 'hover',
};

EpTooltip.propTypes = {
  children: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  trigger: PropTypes.oneOf(['hover', 'click']),
};
